import _get from 'lodash/get'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  formComplete: false,
  formData: {},
  loading: true,
  isDebug: true,
  toggle: false,
  completeToggle: false,
  openOnFocus: true,
  isReadOnly: false,
  mailingTypeList: null,

  showPreview: true,
  showAttachments: true,
  communicationID: 0,
  composedText: '',
  composedSubject: '',
  files: [],
  image: null,
  doc: null,
  previews: [],
  lGet: _get,
  documents: [],
  communicationAttachments: [],
  communicationAttachmentFile: null,
  base64pdf: '',

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
